import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getAboutMetaSliceContent = createAsyncThunk('/aboutMetas/content', async () => {
	const response = await axios.post(`${API_URL}/getAboutMetaData`);
    console.log(response.data);
	return response;
})

export const aboutMetaSlice = createSlice({
    name: 'aboutMetas',
    initialState: {
        isLoading: false,
        aboutMetas : []
    },
    reducers: {
    },
    extraReducers: {
		[getAboutMetaSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getAboutMetaSliceContent.fulfilled]: (state, action) => {
			state.aboutMetas = action.payload.data
			state.isLoading = false
		},
		[getAboutMetaSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default aboutMetaSlice.reducer